export let DomainIntentType = /*#__PURE__*/function (DomainIntentType) {
  DomainIntentType["CONNECT"] = "connect";
  DomainIntentType["CONNECT_DROPSHIPPING"] = "connect-dropshipping";
  DomainIntentType["CONNECT_FUNNEL"] = "connect-funnel";
  DomainIntentType["PURCHASE"] = "purchase";
  DomainIntentType["PURCHASE_DROPSHIPPING"] = "purchase-dropshipping";
  DomainIntentType["PURCHASE_STOREFRONT"] = "purchase-storefront";
  DomainIntentType["PURCHASE_FUNNEL"] = "purchase-funnel";
  DomainIntentType["PURCHASE_AI_FIND_DOMAIN"] = "purchase-ai-find-domain";
  return DomainIntentType;
}({});
export const DOMAIN_INTENT_REFERRAL_VALUES = {
  [DomainIntentType.CONNECT]: 'add-domain-connect-intent',
  [DomainIntentType.CONNECT_DROPSHIPPING]: 'add-domain-connect-intent-dropshipping',
  [DomainIntentType.CONNECT_FUNNEL]: 'add-domain-connect-intent-funnel',
  [DomainIntentType.PURCHASE]: 'add-domain-purchase-intent',
  [DomainIntentType.PURCHASE_DROPSHIPPING]: 'add-domain-purchase-intent-dropshipping',
  [DomainIntentType.PURCHASE_STOREFRONT]: 'add-domain-purchase-intent-storefront',
  [DomainIntentType.PURCHASE_FUNNEL]: 'add-domain-purchase-intent-funnel',
  [DomainIntentType.PURCHASE_AI_FIND_DOMAIN]: 'add-domain-purchase-intent-ai-find-domain'
};
export const getDomainIntentType = referralAdditionalInfo => {
  if (!referralAdditionalInfo) {
    return undefined;
  }
  const entry = Object.entries(DOMAIN_INTENT_REFERRAL_VALUES).find(_ref => {
    let [, value] = _ref;
    return value === referralAdditionalInfo;
  });
  return entry ? entry[0] : undefined;
};
export const isBaseDomainPurchaseIntentReferral = referralAdditionalInfo => {
  const intentType = getDomainIntentType(referralAdditionalInfo);
  return intentType === DomainIntentType.PURCHASE || intentType === DomainIntentType.PURCHASE_FUNNEL || intentType === DomainIntentType.PURCHASE_AI_FIND_DOMAIN;
};

/**
 * Storefront also puts the purchased domain in the page title, but behind the
 * personalization spec rather than `displayDomainNameInTitle` — so it is kept
 * separate from `isBaseDomainPurchaseIntentReferral` instead of joining it.
 * That also leaves the free-domain tooltip copy on the base intents only.
 */
export const isStorefrontPurchaseReferral = referralAdditionalInfo => getDomainIntentType(referralAdditionalInfo) === DomainIntentType.PURCHASE_STOREFRONT;
//# sourceMappingURL=domainIntentReferrals.js.map